/* eslint-disable @typescript-eslint/no-use-before-define */
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import accountInfoAPI from 'services/accountInfo'
import { CardInfoState } from 'typings/reduxStore'
import { ServerError } from 'typings/serverError'
import { redirectTo } from 'ui/customHooks/useHistory'
import { EBPDetails } from 'typings/card'
import { AccountInfoError, GetCardInfoRequest } from './typings'

export const initState: CardInfoState = {
  accountInfo: {
    balance: '0',
    currentBalance: 0,
    bucket1: 0,
    bucket2: 0,
    bucket3: 0,
    bucket4: 0,
    bucket5: 0,
    bucket6: 0,
    unappliedCash: 0,
    unappliedCredits: 0
  },
  creditLimitInfo: {
    availableCreditLimit: '0',
    creditLimit: '0'
  },
  ebpDetails: {
    emailId: '',
    flag: ''
  },
  errorMessage: '',
  isDataLoading: true,
  isResponseFail: false,
  relationship: ''
}

export const getCardInfo = createAsyncThunk(
  'accountInfoSlice/getCardInfo',
  async (payload: GetCardInfoRequest, { dispatch }) => {
    try {
      const response = await accountInfoAPI.getAccountInfo(payload)

      const {
        acctInformation: { accountInfo = [] }
      } = response

      /*
       * This will handle when accountSummary for Prox returns
       * {"acctInformation":{"errors":[{"reason":"TANDEM-ERROR IN SENDING RESPONSE BACK"}]}}
       */
      if ('errors' in response.acctInformation) {
        const errorResponse = response as unknown as AccountInfoError
        const errorMessage = errorResponse.acctInformation.errors[0].reason

        setTimeout(() => {
          redirectTo('error')
        }, 100)

        throw new Error(errorMessage)
      }

      const { bankingInfo, creditLimits, ebpDetails, relationship } =
        accountInfo[0]

      dispatch(
        updateCardInfo({
          accountInfo: bankingInfo,
          childAccounts: accountInfo,
          creditLimitInfo: creditLimits,
          ebpDetails,
          relationship,
          errorMessage: '',
          isDataLoading: false,
          isResponseFail: false
        })
      )
    } catch (error) {
      const errorResponse = error as ServerError

      dispatch(
        updateCardInfo({
          errorMessage: errorResponse.description,
          isDataLoading: false,
          isResponseFail: true
        })
      )
    }
  }
)

export const accountInfoSlice = createSlice({
  name: 'accountInfoSlice',
  initialState: initState,
  reducers: {
    updateCardInfo: (
      state: CardInfoState,
      action: PayloadAction<CardInfoState>
    ) => {
      return {
        ...state,
        ...action.payload
      }
    },
    updateEnrolledEmail(
      state: CardInfoState,
      action: PayloadAction<EBPDetails['emailId']>
    ) {
      state.ebpDetails.emailId = action.payload
    }
  }
})

export const { updateCardInfo, updateEnrolledEmail } = accountInfoSlice.actions

export default accountInfoSlice.reducer
